var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',[_c('line-chart',{attrs:{"data":_vm.data,"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }